import { render, staticRenderFns } from "./PluginLoading.vue?vue&type=template&id=1e6fedba&scoped=true&"
import script from "./PluginLoading.vue?vue&type=script&lang=js&"
export * from "./PluginLoading.vue?vue&type=script&lang=js&"
import style0 from "./PluginLoading.vue?vue&type=style&index=0&id=1e6fedba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6fedba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
